namespace Areas {
    "use strict";

    export class Selected {
        user: any;
    } 
    //grid user lookup
    export function userValueChanged(selected: Selected) {
        return (rowData, value) => {
            if (value === undefined || value === null) {
                rowData.userId = null;
                rowData.userEmail = null;
                rowData.userName = null;
                return;
            }

            if (!selected.user.isActive) {
                DevExpress.ui.notify("The record cannot be updated. The user you selected has been disabled!", "error", 3000);
                return;
            }

            rowData.userId = selected.user.userId;
            rowData.userEmail = selected.user.email;
            rowData.userName = selected.user.displayName;
        }
    }

    export function lookupEditTemplate(loadUrl: string, selected: Selected) {
        return (cellElement, cellInfo) => {
            var storeConfiguration = {
                "loadParams": {},
                "key": "userId",
                "loadUrl": loadUrl,
                "insertUrl": "",
                "updateUrl": "",
                "deleteUrl": ""
            };

            var store = DevExpress.data.AspNet.createStore(storeConfiguration);

            const dataSource = new DevExpress.data.DataSource({
                store: store
            });

            var div = document.createElement("div");
            cellElement.get(0).appendChild(div);
            $(div).dxLookup({
                dataSource: dataSource,
                valueExpr: "userId",
                displayExpr: "displayName",
                value: cellInfo.data.userId,
                searchExpr: ["displayName", "email"],


                onSelectionChanged(e) {
                    selected.user = e.selectedItem;
                },

                onValueChanged(e) {
                    cellInfo.setValue(e.value);
                }
            });

            $(div).dxLookup("instance").option("itemTemplate", customTemplate);
            $(div).dxLookup("instance").option("popupWidth", 500);
        }
    }

    export function lookupCellTemplate(cellElement: any, cellInfo: any) {
        cellElement.text(cellInfo.data.displayName);
    }

    function customTemplate(itemData: any, itemIndex: any, itemElement: any) {
        if (itemData.isActive) {
            itemElement.append(`<div><span class="collookupspan">${itemData.displayName}</span>${itemData.email}</div>`);
        } else {
            itemElement.append(`<div style='color:red;font-style:italic'><span class="collookupspan">${itemData.displayName}</span>${itemData.email} - Disabled<div>`);
        }
    }

}
